import React from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { TAB } from '../itemIds';

interface Props {
  value?: string;
  iterator?: number;
}

export type TabDefinition = ItemDefinition<typeof TAB, Props>;

export class Tab extends Item<typeof TAB, Props> {
  protected render({ children }: RenderProps<Props>) {
    return <>{children}</>;
  }
}

registry[TAB] = Tab;
